var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
var LayoutMixin = /** @class */ (function (_super) {
    __extends(LayoutMixin, _super);
    function LayoutMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    Object.defineProperty(LayoutMixin.prototype, "snackbar", {
        /**
         * Snackbar
         */
        get: function () {
            return this.store.app.snackbar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutMixin.prototype, "fluid", {
        /**
         * Layout set to fluid
         */
        get: function () {
            return this.store.app.fluid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutMixin.prototype, "sideNavigationVisible", {
        /**
         * Side navigation visible
         */
        get: function () {
            return this.store.app.sideNavigationVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutMixin.prototype, "contentSize", {
        get: function () {
            return this.store.app.contentSize;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @function ToggleFluidLayout
     * @description Toggle the fluid layout
     */
    LayoutMixin.prototype.toggleFluidLayout = function () {
        this.store.app.toggleFluidLayout();
    };
    LayoutMixin.prototype.openSideNavigation = function () {
        this.store.app.openSideNavigation();
    };
    LayoutMixin.prototype.closeSideNavigation = function () {
        this.store.app.closeSideNavigation();
    };
    /**
     * @function ToggleSideNaviation
     * @description Toggle the side navigation
     */
    LayoutMixin.prototype.toggleSideNavigation = function () {
        if (this.store.app.sideNavigationVisible) {
            this.store.app.closeSideNavigation();
        }
        else {
            this.store.app.openSideNavigation();
        }
    };
    LayoutMixin.prototype.setContentSize = function (x, y) {
        this.store.app.setContentSize({ x: x, y: y });
    };
    LayoutMixin = __decorate([
        Component
    ], LayoutMixin);
    return LayoutMixin;
}(Vue));
export default LayoutMixin;
